import Vue from 'vue';
import VueI18n from 'vue-i18n';
import axios from 'axios';
import AuthService from '@/services/auth.service';
import { Locales } from "@/i18n/locales";
import { User } from 'oidc-client';

const auth = new AuthService();
const defaultLocale = localStorage.getItem("language") || Locales.EN;

Vue.use(VueI18n);

export const i18n = new VueI18n({
    locale: Locales.EN, // set locale
    fallbackLocale: Locales.EN,
    messages: {}
})

const loadedLanguages = [Locales.EN] // our default language that is preloaded

function setI18nLanguage(lang) {
    i18n.locale = lang
    axios.defaults.headers.common['Accept-Language'] = lang
    document.querySelector('html').setAttribute('lang', lang)
    return lang
}

export async function loadLanguageAsync(lang) {
    await auth.isLoggedIn().then((isLoggedIn: boolean) => {
        if (isLoggedIn && !localStorage.getItem("ddlChanged")) {
            auth.getUser().then((user: User) => {
                lang = user?.profile?.default_language || Locales.EN;
                localStorage.setItem("language", lang);

                i18n.locale = lang;

                axios.get(process.env.VUE_APP_API_Base_URL + 'api/LanguageManager/' + lang).then((res) => {
                    i18n.setLocaleMessage(lang, JSON.parse(res.data.Record))
                    loadedLanguages.push(lang);

                    return setI18nLanguage(lang)
                })
            });
        } else {
            if (!localStorage.getItem("language"))
                localStorage.setItem("language", lang);

            i18n.locale = lang;

            axios.get(process.env.VUE_APP_API_Base_URL + 'api/LanguageManager/' + lang).then((res) => {
                i18n.setLocaleMessage(lang, JSON.parse(res.data.Record))
                loadedLanguages.push(lang);

                return setI18nLanguage(lang)
            })
        }
    });


}